export default {"src":"/_next/static/media/time.217c0ac6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};